const accountDetails = {
  accountDetails: {
    managePreferences: 'Cambiar las preferencias',
    email: 'Email',
    emailChangeText: 'Aún tiene que confirmar su cambio de dirección de email!',
    confirmationText: 'Hemos enviado un email de confirmación a %{email}. Debe hacer clic en el vínculo de ese mensaje para que su cambio de email surta efecto.',
    resendConfirmationEmail: 'Reenviar email de confirmación',
    cancelChange: 'Cancelar este cambio',
    firstName: 'Nombre',
    lastName: 'Apellido',
    phone: 'Teléfono',
    company: 'Nombre de la empresa',
    saveDetails: 'Guardar detalles de la cuenta',
    changeEmailRequest: 'Cambiar e-mail',
    job_profile: {
      label: "Seleccione el perfil profesional de la persona en la empresa",
      tooltip_msg: 'Seleccione el perfil laboral principal de la persona. Si el usuario tiene más de un rol principal, seleccione "Otros".'
    }
  },
  resetPassword: {
    instructions: 'Su contraseña debe contar con una extensión mínima de seis caracteres; además, debe contener al menos un número o carácter especial y no puede ser la misma que su dirección de email.',
    currentPassword: 'Contraseña actual',
    newPassword: 'Introduzca la nueva contraseña',
    confirmNewPassword: 'Confirme la nueva contraseña',
  }
};

export default accountDetails;